"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processLinks = exports.loadSearchData = exports.paginate = exports.getFiltersData = exports.deleteBySearchId = exports.storeExpiration = exports.storeCompleteSearchData = exports.clearTables = exports.checkExpiration = exports.getExpirationData = exports.getSearchData = void 0;
const indexDb_1 = require("../../../shared/helpers/indexDb");
const StringHelper_1 = __importDefault(require("../../../shared/helpers/StringHelper"));
const AccessibilityApi_1 = require("../apis/AccessibilityApi");
const helpers_1 = require("../../../shared/helpers");
const getSearchData = (search_id) => __awaiter(void 0, void 0, void 0, function* () {
    const { getAllBy } = indexDb_1.indexDbConsulta;
    return yield getAllBy('consulta', search_id, 'search_id');
});
exports.getSearchData = getSearchData;
const getExpirationData = (search_text) => __awaiter(void 0, void 0, void 0, function* () {
    const { getBy } = indexDb_1.indexDbConsulta;
    return yield getBy('expiracao', search_text);
});
exports.getExpirationData = getExpirationData;
const checkExpiration = (expiresData) => {
    const { expires } = expiresData;
    const now = new Date().getTime();
    return expires > now;
};
exports.checkExpiration = checkExpiration;
const clearTables = () => __awaiter(void 0, void 0, void 0, function* () {
    const { clearTables } = indexDb_1.indexDbConsulta;
    yield clearTables(['consulta', 'expiracao']);
});
exports.clearTables = clearTables;
const storeCompleteSearchData = (search_data) => __awaiter(void 0, void 0, void 0, function* () {
    const { insertData } = indexDb_1.indexDbConsulta;
    return yield insertData('consulta', search_data);
});
exports.storeCompleteSearchData = storeCompleteSearchData;
const storeExpiration = (expiration) => __awaiter(void 0, void 0, void 0, function* () {
    const { insertData } = indexDb_1.indexDbConsulta;
    return yield insertData('expiracao', expiration);
});
exports.storeExpiration = storeExpiration;
const deleteBySearchId = (search_id) => __awaiter(void 0, void 0, void 0, function* () {
    const { deleteAllByIndex } = indexDb_1.indexDbConsulta;
    yield deleteAllByIndex('consulta', search_id, 'search_id');
    yield deleteAllByIndex('expiracao', search_id, 'search_id');
});
exports.deleteBySearchId = deleteBySearchId;
const getFiltersData = (data) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        try {
            const filters = data.reduce((acumulador, element) => {
                if (element.dados_adicionais.hasOwnProperty('B')) {
                    const { B } = element.dados_adicionais;
                    if (B.length > 0) {
                        const dataNoAdded = B.filter(b => !acumulador.libraries.some(acm => acm.code === b.code));
                        acumulador.libraries = [
                            ...acumulador.libraries,
                            ...dataNoAdded,
                        ];
                    }
                }
                if (element.dados_adicionais.hasOwnProperty('T')) {
                    const { cod_tipo_obra: code, desc_tipo_obra: description, } = element;
                    if (code &&
                        !acumulador.typeOfWork.some(acm => acm.code === code)) {
                        acumulador.typeOfWork.push({
                            code,
                            description: StringHelper_1.default.replaceAll(description, ['(', ')'], '').trim(),
                        });
                    }
                }
                return acumulador;
            }, { typeOfWork: [], libraries: [] });
            filters.typeOfWork.sort((a, b) => a.description.localeCompare(b.description));
            filters.libraries.sort((a, b) => a.description.localeCompare(b.description));
            resolve(filters);
        }
        catch (e) {
            reject(e);
        }
    });
});
exports.getFiltersData = getFiltersData;
const paginate = (data, itemsPerPage, page) => {
    const startIndex = 0;
    let endIndex = page * itemsPerPage - 1;
    if (endIndex > data.length)
        endIndex = data.length;
    return data.slice(startIndex, endIndex);
};
exports.paginate = paginate;
const loadSearchData = (searchText, accessibleTitleSearch, cancelToken) => __awaiter(void 0, void 0, void 0, function* () {
    let expiresData = null;
    try {
        expiresData = yield (0, exports.getExpirationData)(accessibleTitleSearch === 'N'
            ? searchText.trim()
            : 'accessibilitySearchTitlesData');
        if (expiresData) {
            if ((0, exports.checkExpiration)(expiresData)) {
                const { search_id } = expiresData;
                return yield (0, exports.getSearchData)(search_id);
            }
            throw new Error('data expired');
        }
    }
    catch (e) {
        console.error(e);
        if (expiresData !== null) {
            yield (0, exports.deleteBySearchId)(expiresData.search_id);
        }
    }
    try {
        const response = yield (0, AccessibilityApi_1.getSearch)(searchText.trim(), accessibleTitleSearch, cancelToken);
        if (response) {
            const { data } = response;
            if (data.length > 0) {
                const hours = 1;
                const dataExpires = {
                    expires: new Date().getTime() + hours * 60 * 60 * 1000,
                    search_id: data[0].search_id,
                    search_text: accessibleTitleSearch === 'N'
                        ? searchText.trim()
                        : 'accessibilitySearchTitlesData',
                };
                yield indexDb_1.indexDbConsulta.insertData('consulta', data);
                yield indexDb_1.indexDbConsulta.insertData('expiracao', dataExpires);
                return data;
            }
        }
        helpers_1.ToastifyHelper.warning(`Nenhum resultado foi  encontrado para essa pesquisa."`);
    }
    catch (e) {
        helpers_1.APIHelper.tratarErro(e);
    }
    return false;
});
exports.loadSearchData = loadSearchData;
const processLinks = () => { };
exports.processLinks = processLinks;
